import { styled, lighten } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const CategoryNameWrapper = styled(Grid)(({ theme }) => ({
  width: "100%",
  backgroundColor: lighten(theme.palette.secondary.light, 0.8),
}));

export const CategoryNameContainer = styled(Grid)(({ theme }) => ({
  padding: "20px",
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
}));

export const TitleBlock = styled(Grid)(({ theme }) => ({
  minHeight: "35px",
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  padding: "20px",
  backgroundColor: lighten(theme.palette.secondary.light, 0.85),
}));

export const TitleName = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
}));

export const MainColumnBlock = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "withPadding",
})<{ withPadding?: boolean }>(
  {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& > p": {
      fontSize: "1em",
      display: "flex",
    },

    "& .MuiButtonBase-root": {
      margin: 3,
      fontSize: "1em",
      visibility: "hidden",
    },

    "&:hover .MuiButtonBase-root": {
      visibility: "visible",
    },
  },
  ({ withPadding }) => ({
    ...(!!withPadding && {
      padding: "10px",
      paddingLeft: "80px",
    }),
  })
);

export const CellBlock = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexFlow: "column",
  textAlign: "center",
  justifyContent: "flex-end",
  position: "relative",

  "&:hover div > div": {
    visibility: "visible",
    opacity: 1,
  },

  "&:hover button:first-of-type": {
    visibility: "visible",
    opacity: 1,
  },

  "& .MuiButton-root": {
    fontSize: "0.85em",
  },
  "& .MuiTypography-body1": {
    fontSize: "0.85em",
  },
}));

export const DeadlineAndActions = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "deadlineOverdued",
})<{
  deadlineOverdued: boolean;
}>(
  {
    display: "flex",
    justifyContent: "flex-end",

    "& > button": {
      alignSelf: "flex-end",
      // padding: 0,
      visibility: "hidden",
      opacity: 0,
      transition: "all .3s ease",
    },

    "&:hover button": {
      visibility: "visible",
      opacity: 1,
    },
  },
  ({ deadlineOverdued, theme }) => ({
    ...(deadlineOverdued && {
      borderBottom: `3px solid ${theme.palette.error.main}`,
    }),
  })
);
